import { useState, useRef, Suspense } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { Points, PointMaterial, Preload } from "@react-three/drei";
import * as random from "maath/random/dist/maath-random.esm";
import { div } from "three/examples/jsm/nodes/Nodes.js";

const Stars = (props) => {
  const ref = useRef();
  const sphere = random.inSphere(new Float32Array(10000), {radius: 1.2})

  useFrame((state, delta) => {
    ref.current.rotation.x -= delta / 10;
    ref.current.rotation.y -= delta / 15;
  })
  return (
    <group rotation={[0, 0, Math.PI / 4]}>
      <Points ref={ref} positions={sphere} stride={3} frustumCulled {...props}>
        <PointMaterial
        transparent
        color='#f272c8'
        size={0.001}
        sizeAttenuation={true}
        depthWrite={false}/>
      </Points>
    </group>
  )
}

const StarsCanvas = () => {
return (
  <div style={{ width: '100%', height: '100rem', position: 'absolute', top: '0', left: '0', right: '0', bottom: '0', zIndex: '-1'}}>
    <Canvas camera={{ position: [0, 0, 1]}}>
      <Suspense fallback={null}>
        <Stars/>
      </Suspense>
      <Preload all />
    </Canvas>

  </div>
)
}

export default StarsCanvas